module.exports = __webpack_public_path__ + "static/media/pivotshot-removedbg.652e2a28.png";